import { Fragment, useContext } from 'react';
import HeroSection from './components/HeroSection';
import MembershipBenefits from './components/MembershipBenefits';
import Categories from './components/Categories';
import VerifiedMemberPoints from './components/VerifiedMemberPoints';
import EthicsCode from './components/EthicCodes';
import CommitCodeEthic from './components/CommitCodeEthic';
import CertificateSample from './components/CertificateSample';
import NeedHelp from './components/NeedHelp';
import { AuthContext } from '../../Contexts/AuthContext';

const verifiedMemberPoints = [
    {
        name: "Register in Minutes",
        title: "Complete our simple onboarding form.",
        path: "/assets/services/1/verified-member/clipboard-check.png",
        description: "Complete our simple onboarding form."
    },
    {
        name: "Professional Website",
        title: "Professional Website",
        path: "/assets/services/1/verified-member/website.png",
        description: "Present your profile and services with impact."
    },
    {
        name: "Showcase Expertise",
        title: "Showcase Expertise",
        path: "/assets/services/1/verified-member/showcase.png",
        description: "Highlight your certifications and achievements."
    },
    {
        name: "Nationwide Presence",
        title: "Nationwide Presence",
        path: "/assets/services/1/verified-member/navigation.png",
        description: "Be listed on India’s trusted professional network."
    },
    {
        name: "Quality Client Leads",
        title: "Quality Client Leads",
        path: "/assets/services/1/verified-member/leads.png",
        description: "Receive direct enquiries from genuine prospects."
    },
    {
        name: "Career & Income Growth",
        title: "Career & Income Growth",
        path: "/assets/services/1/verified-member/growth.png",
        description: "Build credibility and expand your reach."
    }
]

const members = [
    {
        alt: 'check-circle',
        icon: "/assets/services/1/benefits/check-circle.png",
        title: "Official FWPI Membership Certificate",
        description: "A prestigious recognition of your professional affiliation with FWPI, enhancing your credibility."
    },
    {

        alt: 'offers',
        icon: "/assets/services/1/benefits/offers.png",
        title: "Partner Supplement & Equipment Offers",
        description: "Exclusive discounts on top supplement brands and gym equipment through our trusted partners."
    },
    {

        alt: 'networks',
        icon: "/assets/services/1/benefits/networks.png",
        title: "National Network",
        description: "Connect with certified fitness and wellness professionals across India, and collaborate on growth opportunities."
    },
    {

        alt: 'directory',
        icon: "/assets/services/1/benefits/directory.png",
        title: "Listing in FWPI Members Directory",
        description: "Get listed in the official FWPI Members Directory, enhancing your visibility and networking opportunities."
    },
    {

        alt: 'job-placement',
        icon: "/assets/services/1/benefits/job-placement.png",
        title: "Priority in Job Placements",
        description: "Receive priority access to job opportunities shared by FWPI partner gyms, studios, and companies."
    },
    {

        alt: 'courses',
        icon: "/assets/services/1/benefits/courses.png",
        title: "Special Discounts on Courses & Certifications",
        description: "Enjoy exclusive discounts on workshops, certifications, and tuition education programs."
    },
    {

        alt: 'status',
        icon: "/assets/services/1/benefits/status.png",
        title: "Eligible for Approved Training Provider (ATP) Status",
        description: "Apply for ATP status, allowing you to offer FWPI-recognized certifications and programs."
    },
    {

        alt: 'ideas',
        icon: "/assets/services/1/benefits/ideas.png",
        title: "Support for Business Ideas",
        description: "Get mentorship and guidance from our advisory panel to launch, grow, or scale your fitness business."
    },
    {

        alt: 'setup',
        icon: "/assets/services/1/benefits/setup.png",
        title: "Free Gym Setup Consultation",
        description: "Access expert consultation for setting up or upgrading your fitness facility."
    },
    {

        alt: 'access',
        icon: "/assets/services/1/benefits/access.png",
        title: "Priority Access",
        description: "Gain priority entry to FWPI programs, events, workshops, and other exclusive member initiatives."
    }
];

const categoriesData = [
    'Personal Trainer',
    'Fitness Trainer',
    'Group Fitness Instructor',
    'Strength & Conditioning Coach',
    'Yoga Instructor',
    'Pilates Instructor',
    'Dance Instructor',
    'Physiotherapist',
    'Nutrition Advisor',
    'Clinical Nutrition Advisor',
    'Wellness Coach',
    'Health Coach',
    'Gym Instructor',
    'Sports Coach',
    'Pilates Instructor',
    'Dance Instructor',
];

const ethicsPrinciples = [
    {
        id: 1,
        title: "Professional Competence",
        content: "Members must maintain up-to-date knowledge, skills, and qualifications relevant to their professional practice. This includes pursuing continuing education and applying evidence-based methods to deliver safe and effective services."
    },
    {
        id: 2,
        title: "Honesty & Transparency",
        content: "All communications with clients, colleagues, and the public should be truthful, clear, and free from misleading claims. Members must disclose qualifications, pricing, and service limitations openly."
    },
    {
        id: 3,
        title: "Practice Within Scope",
        content: "Members must only provide services for which they are qualified and refer clients to appropriate experts when necessary. A fitness trainer should not prescribe medical diets or diagnose injuries unless additionally qualified."
    },
    {
        id: 4,
        title: "Client-Centered Care",
        content: "Every service should be tailored to the unique needs, goals, and safety of each client. Designing programs based on client fitness levels, health history, and cultural considerations."
    },
    {
        id: 5,
        title: "Confidentiality & Data Protection",
        content: "Client information must be kept private and secure. Members must not disclose personal data or health records without explicit consent, except where legally required."
    },
    {
        id: 6,
        title: "Maintaining Professional Boundaries",
        content: "Members must avoid dual relationships, favoritism, or inappropriate personal involvement with clients. Professional interactions should always prioritize the client’s well-being."
    },
    {
        id: 7,
        title: "Safety & Risk Management",
        content: "All programs, equipment use, and environments should prioritize safety. Members must assess risks, provide proper instruction, and take precautions to prevent injury or harm."
    },
    {
        id: 8,
        title: "Respect for Cultural & Individual Diversity",
        content: "Members must respect and accommodate differences in culture, background, gender, ability, and personal values. Discrimination, harassment, or bias in any form is unacceptable."
    },
    {
        id: 9,
        title: "Effective Communication",
        content: "Clear, respectful, and professional communication is essential. Members should listen actively, provide understandable guidance, and encourage client feedback to foster trust."
    },
    {
        id: 10,
        title: "Ethical Marketing & Advertising",
        content: "Promotional materials must be accurate, evidence-based, and free of exaggerated claims. Members should avoid false promises or exploiting client insecurities for commercial gain."
    },
    {
        id: 11,
        title: "Commitment to Continued Learning",
        content: "Members must actively pursue opportunities for professional development. This includes attending workshops, staying updated with research, and integrating new knowledge into practice."
    },
    {
        id: 12,
        title: "Punctuality & Professional Conduct",
        content: "Members must arrive on time, prepared, and conduct themselves with professionalism. This includes reliability, respectful behavior, and accountability in all commitments."
    },
    {
        id: 13,
        title: "Appearance & Hygiene",
        content: "Maintaining appropriate personal hygiene and professional appearance ensures a safe, comfortable, and respectful environment for clients and colleagues."
    },
    {
        id: 14,
        title: "Conflict Resolution",
        content: "Disputes with clients, colleagues, or employers should be addressed calmly, fairly, and professionally. Members should seek constructive solutions and, where necessary, mediation."
    },
    {
        id: 15,
        title: "Legal & Regulatory Compliance",
        content: "Members must comply with all applicable laws, regulations, and industry standards. This includes respecting contracts, health and safety codes, and professional licensing requirements."
    },
];

const OurServices = () => {

    const { token, setIsLoginModal } = useContext(AuthContext);

    return (
        <Fragment>
            <HeroSection />
            <MembershipBenefits
                title={'FWPI Membership Benefits'}
                description='As a member, you will'
                benefits={members}
            />
            <Categories
                title={'Who can Apply ?'}
                description={'Category'}
                tags={categoriesData}
            />
            <VerifiedMemberPoints
                title="Become a Verified FWPI Member"
                items={verifiedMemberPoints}
            />
            <EthicsCode
                title={'FWPI CODE OF ETHICS'}
                description={'As a member of the Fitness & Wellness Professionals of India (FWPI), every professional commits to upholding the following ethical principles to ensure integrity, client safety, and public trust in the wellness industry.'}
                items={ethicsPrinciples}
            />
            <CommitCodeEthic
                title={'Commit to Code of Ethics'}
                description={'All members must agree to follow the FWPI Code of Ethics, promoting professionalism, authenticity, responsibility, and recognition.'}
                buttonName={'Apply Now'}
                pathname={!!token ? '/my-profile' : '/trainer/create'}
                onClick={() => {
                    if (!token) {
                        setIsLoginModal(true);
                    }
                }}
            />
            <CertificateSample />
            <NeedHelp />
        </Fragment>
    );
}

export { OurServices };
